import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from '../../api/axiosConfig';
import PrintableExpenseReport from '../printable/PrintableExpenseReport'; // Correct path
import LoadingSpinner from '../../components/common/LoadingSpinner';

// Define the expected structure of the fetched report data
// (Should match the structure returned by getExpenseReport)
interface ExpenseReportData {
  expenses: Array<{
    id: number;
    date: string;
    category: string;
    subcategory?: string | null;
    description: string;
    amount: number;
    createdBy: string;
    method?: string | null;
  }>;
  totalAmount: number;
  startDate: string;
  endDate: string;
  categoryFilter?: string;
}

const ExpenseReportPrintPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const startDate = searchParams.get('startDate');
  const endDate = searchParams.get('endDate');
  const category = searchParams.get('category'); // Get optional category filter

  const [reportData, setReportData] = useState<ExpenseReportData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchReportData = async () => {
      if (!startDate || !endDate) {
        setError('Не указан период для отчета.');
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);
      try {
        // Use the new backend endpoint for expense report print data
        const response = await axios.get<ExpenseReportData>(`/reports/expenses/print-data`, {
          params: { startDate, endDate, category: category === 'all' ? undefined : category } // Pass filters
        });
        // Add startDate and endDate to the fetched data for the printable component
        setReportData({ ...response.data, startDate, endDate, categoryFilter: category || undefined });
        // Attempt to trigger print dialog after data is loaded
        setTimeout(() => {
          // window.print();
        }, 500); // Small delay
      } catch (err: any) {
        console.error('Error fetching expense report data for printing:', err);
        setError(err.response?.data?.message || 'Не удалось загрузить данные отчета для печати.');
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [startDate, endDate, category]); // Depend on query parameters

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="printable-container error-message">Ошибка: {error}</div>;
  }

  if (!reportData) {
    return <div className="printable-container">Данные для печати не найдены.</div>;
  }

  // Render the printable component with the fetched data
  return <PrintableExpenseReport reportData={reportData} />;
};

export default ExpenseReportPrintPage;
